import * as forms from "./formSchema";
import * as time from "./time";
import * as files from "./files";
import * as virtualClass from "./virtualClass";
import * as strings from "./strings"
import * as assigment from './assignment';

const UTILS = {
    forms,
    time,
    files,
    strings,
    virtualClass,
    assigment
}

export default UTILS;
